import { render } from "./DashboardWelcomeSlider.vue?vue&type=template&id=bb5a2272"
import script from "./DashboardWelcomeSlider.vue?vue&type=script&lang=js"
export * from "./DashboardWelcomeSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__